import type { AgentApiJobSourcesIndex } from '@/types/serializers';
import { useQuery } from '@tanstack/react-query';

export default function useFetchJobSources(serviceType: 'normal' | 'database') {
  return useQuery({
    queryKey: ['jobSources', serviceType],
    queryFn: async () => {
      const url = `/agent/api/job_sources.json?service_type=${serviceType}`;
      const response = await fetch(url);
      const data: AgentApiJobSourcesIndex = await response.json();

      return data;
    },
  });
}
